"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _videoFiltersHelper, _videoFilterInConferenceController;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoFiltersService = void 0;
const Service_1 = require("../Service");
const VideoFilterInConferenceController_1 = require("./VideoFilterInConferenceController");
const VideoFiltersHelper_1 = require("./VideoFiltersHelper");
/**
 * The VideoFiltersService manages the video filters that allow blurring the local participant's background or using a selected image as the local participant's background. The video filters are available only for the Dolby.io Communications SDK for Desktop users. The service allows [checking](#getsupportedfilters) the available video filters and [applying](#setfilter) the selected filter on the proper video stream.
 *
 */
class VideoFiltersService extends Service_1.BaseConferenceService {
    /**
     * @ignore
     */
    constructor(sdk, conferenceService, sessionService) {
        super(sdk);
        _videoFiltersHelper.set(this, void 0);
        _videoFilterInConferenceController.set(this, void 0);
        __classPrivateFieldSet(this, _videoFiltersHelper, new VideoFiltersHelper_1.VideoFiltersHelper());
        __classPrivateFieldSet(this, _videoFilterInConferenceController, new VideoFilterInConferenceController_1.VideoFilterInConferenceController(conferenceService, sessionService, __classPrivateFieldGet(this, _videoFiltersHelper)));
    }
    /**
     * Returns video filters that are available for the local participant.
     *
     * The [bokeh](doc:js-client-sdk-model-videofilters#bokeh) and [staticImage](doc:js-client-sdk-model-videofilters#staticimage) filters are available only for the Dolby.io Communications SDK for Desktop users and are not supported on any other platform.
     */
    getSupportedFilters() {
        return [...__classPrivateFieldGet(this, _videoFiltersHelper).supportedFilters];
    }
    /**
     * Applies the selected video filter on the local participant's video stream.
     *
     * @param filter - The selected video filter.
     * @param options - The video filter options. The options include the image file for the [staticImage](doc:js-client-sdk-model-videofilters#staticimage) filter and information about the video stream on which the video filter should be applied.
     */
    setFilter(filter, options = {}) {
        return options.stream === undefined
            ? __classPrivateFieldGet(this, _videoFilterInConferenceController).setFilter(filter, options)
            : __classPrivateFieldGet(this, _videoFiltersHelper).setFilter(options.stream, filter, options);
    }
}
exports.VideoFiltersService = VideoFiltersService;
_videoFiltersHelper = new WeakMap(), _videoFilterInConferenceController = new WeakMap();
